<form lin-layout-form [formGroup]="form" (ngSubmit)="correctInstallationDate()">
  <lin-form-label>{{ 'DIALOGS.CORRECT_INSTALLATION_TIME.CURRENT_DATE' | translate }}</lin-form-label>
  <mat-form-field>
    <input matInput formControlName="installDate" />
    <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
  </mat-form-field>

  <lin-form-label required>{{ 'DIALOGS.CORRECT_INSTALLATION_TIME.CORRECTED_DATE' | translate }}</lin-form-label>
  <lin-datepicker-field
    formControlName="correctedDate"
    [isPlaceholderShown]="true"
    [isWithTimePicker]="true"
    [noAutoApply]="true"
    [minDate]="currentInstallDateFormatted"
  ></lin-datepicker-field>

  <div class="info">
    <span>{{ 'DIALOGS.CORRECT_INSTALLATION_TIME.VALUE_RULE' | translate }}</span>
  </div>

  <div class="info">
    <span>{{ 'DIALOGS.CORRECT_INSTALLATION_TIME.WARNING' | translate }}</span>
  </div>

  <lin-form-submit-button [isLoading]="isSubmitting"> {{ 'BUTTONS.SAVE' | translate }} </lin-form-submit-button>
</form>
